import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { userContext } from "../Context/userContext";
import Loading from "./Loading";

import "../css/LynxStyle.css";

const WinnerCheck = () => {
  const { Msisdn } = useContext(userContext);
  const [loading, setLoading] = useState(true);
  const [winners, setWinners] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    axios
      .get(`https://lynxlife.club/api/lv1/winners/${Msisdn}`)
      .then((res) => {
        setWinners(res.data.items || []);
        setLoading(false);
      })
      .catch(() => {
        setError("Couldn't load winners right now. Please try again.");
        setLoading(false);
      });
  }, [Msisdn]);

  return (
    <div className="container">
      <br />
      <br />
      <h3 className="text-white">🏆 Winner Check</h3>
      <div className="lynx-page-card">
        {loading ? (
          <Loading heading="Checking for winners..." />
        ) : error ? (
          <p className="text-white text-center">{error}</p>
        ) : winners.length === 0 ? (
          <p className="text-white text-center">
            No winners yet — check back soon!
          </p>
        ) : (
          <ul className="list-group list-group-flush">
            {winners.map((w, index) => (
              <li
                key={index}
                className="list-group-item bg-transparent border-0 d-flex justify-content-between align-items-center flex-wrap"
              >
                <span className="smsgpt fw-bold">🏆 {w.msisdn}</span>
                <span className="text-white">{w.airtime} airtime</span>
                <small className="text-white opacity-75">{w.stamp}</small>
              </li>
            ))}
          </ul>
        )}
      </div>
      <p className="text-white text-center mt-3">
        <small>
          All active subscribers are automatically entered — see Terms for
          details.
        </small>
      </p>
    </div>
  );
};

export default WinnerCheck;
